import { TickerService } from '@resn/gozer-services';

import { scheduleHandler, unscheduleHandler } from './engine.js';
import { observe } from './observe.js';

const handleEffect = (getValue, { onHandler, offHandler, whileHandler, setHandler }) => {
    let isBoolean;
    let value;
    let prevValue;
    let wasFirstTrigger = true;
    let isFirstTrigger = true;

    if (onHandler) {
        const onHandlerFn = onHandler;
        onHandler = () => {
            onHandlerFn({ firstTrigger: wasFirstTrigger });
        };
    }

    if (offHandler) {
        const offHandlerFn = offHandler;
        offHandler = () => {
            offHandlerFn({ firstTrigger: wasFirstTrigger });
        };
    }

    if (setHandler) {
        const setHandlerFn = setHandler;
        setHandler = () => {
            setHandlerFn(value, { prevValue, firstTrigger: wasFirstTrigger });
        };
    }

    const cleanupObserve = observe(() => {
        const v = getValue();

        prevValue = value;
        value = v;

        if (prevValue === value) {
            return;
        }

        if (isFirstTrigger) {
            isBoolean = typeof value === 'boolean';
        }

        if (setHandler) {
            scheduleHandler(setHandler);
        }

        if (isBoolean) {
            if (value) {
                if (onHandler) {
                    scheduleHandler(onHandler);
                }

                if (whileHandler) {
                    TickerService.add(whileHandler);
                    // ticker.on(whileHandler);
                }
            } else {
                if (offHandler) {
                    scheduleHandler(offHandler);
                }

                if (whileHandler) {
                    TickerService.remove(whileHandler);
                    // ticker.off(whileHandler);
                }
            }
        }

        wasFirstTrigger = isFirstTrigger;
        isFirstTrigger = false;
    });

    return () => {
        if (whileHandler) {
            TickerService.remove(whileHandler);
            // ticker.off(whileHandler);
        }
        if (onHandler) {
            unscheduleHandler(onHandler);
        }
        if (offHandler) {
            unscheduleHandler(offHandler);
        }
        if (setHandler) {
            unscheduleHandler(setHandler);
        }
        cleanupObserve();
    };
};

const effect = (getValue, handlerOrHandlers) =>
    handleEffect(
        getValue,
        typeof handlerOrHandlers === 'function' ? { setHandler: handlerOrHandlers } : handlerOrHandlers,
    );
const onEffect = (getValue, onHandler) => handleEffect(getValue, { onHandler });
const offEffect = (getValue, offHandler) => handleEffect(getValue, { offHandler });
const boolEffect = (getValue, onHandler, offHandler) => handleEffect(getValue, { onHandler, offHandler });
const whileEffect = (getValue, whileHandler) => handleEffect(getValue, { whileHandler });

export { effect, onEffect, offEffect, boolEffect, whileEffect };
